import { utilTime } from "./utilTime";
var UtilLimitedActionTime = /** @class */ (function () {
    function UtilLimitedActionTime() {
        this.getLimitedActionResetRemainingTime = function (limitedActionInfo) {
            var secondsLeft = Number.MAX_VALUE;
            if (limitedActionInfo) {
                if (limitedActionInfo.secondsUntilReset) {
                    var secondsUntilReset = limitedActionInfo.secondsUntilReset, createdAt = limitedActionInfo.createdAt;
                    var secondsElapsed = utilTime.secondsElapsedSince(createdAt);
                    secondsLeft = Math.max(0, secondsUntilReset - secondsElapsed);
                }
                else {
                    secondsLeft = 0;
                }
            }
            return secondsLeft;
        };
        this.getResetTimestamp = function (limitedActionInfo) {
            if (limitedActionInfo == undefined) {
                return utilTime.now();
            }
            var secondsUntilReset = limitedActionInfo.secondsUntilReset, createdAt = limitedActionInfo.createdAt;
            return (createdAt || utilTime.now()) + utilTime.secondsToMs(secondsUntilReset || 0);
        };
        this.getLimitedActionProgress = function (limitedActionInfo) {
            if (limitedActionInfo &&
                limitedActionInfo.resetDurationInSeconds &&
                limitedActionInfo.secondsUntilReset) {
                return ((limitedActionInfo.resetDurationInSeconds - limitedActionInfo.secondsUntilReset) /
                    limitedActionInfo.resetDurationInSeconds);
            }
            return 0;
        };
    }
    return UtilLimitedActionTime;
}());
export var utilLimitedActionTime = new UtilLimitedActionTime();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilLimitedActionTime.ts
// module id = 197
// module chunks = 3